import React from 'react';
import { Chip } from '@heroui/react';
import { Typography } from '../../components';
import IcArrowGreen from '../Arrowgreen.svg';
import IcArrowRed from '../Arrowred.svg';

interface StatCardProps {
  title: string;
  date: string;
  value: string;
  percent: string;
  isPositive: boolean;
}

export function StatCard({ title, date, value, percent, isPositive }: StatCardProps) {
  const arrowIcon = isPositive ? IcArrowGreen : IcArrowRed;
  const chipBgColor = isPositive ? 'bg-[#daf5e1]' : 'bg-[#ffd5e0]';
  const chipTextColor = isPositive ? 'text-successDeep' : 'text-dangerDeep';

  return (
    <div className="flex flex-col md:pb-5 p-4 gap-3 md:gap-4">
      <div className="flex items-center gap-2">
        <Typography variant="body2" className="text-sm font-medium text-neutral-800">
          {title}
        </Typography>
        <Chip
          className="bg-auth-strength-none/40 text-auth-muted text-xs h-5 font-medium rounded-full"
          classNames={{
            content: 'p-0',
            base: 'px-2',
          }}
        >
          {date}
        </Chip>
      </div>
      <div className="flex items-center justify-between">
        <span className="text-2xl font-semibold text-neutral-900">{value}</span>
        <Chip
          className={`h-6 ${chipBgColor} ${chipTextColor} !text-xxs !font-normal min-w-[3.0625rem] text-right`}
          classNames={{
            content: 'p-1.5',
            base: 'px-0 !rounded-2',
          }}
        >
          <div className="flex items-center gap-0.5 h-3">
            <div className="icon size-3">
              <img src={arrowIcon} alt="Arrow" width={12} height={12} />
            </div>
            <Typography
              className={`${chipTextColor} text-xxs leading-auto font-regular`}
              variant="label4"
            >
              {percent}
            </Typography>
          </div>
        </Chip>
      </div>
    </div>
  );
}
